import mami from './mani.png';
import pedi from './pedi.png';
import mp from './mp.png';
import gel from './gel.png';
import fs from './fs.png';
import wax from './wax.png';
import lash from './lash.png';
import fill from './fill.png';
import pw from './pw.png';
import dip from './dip.png';
const serviceAssets: Record<string, string> =
{
  ['Mani']: mami,
  ['Pedi']: pedi,
  ['M/P (Mani & Pedi)']: mp,
  ['Gel']: gel,
  ['FS']: fs,
  ['Wax']: wax,
  ['Lash']: lash,
  ['Fill']: fill,
  ['P/W']: pw,
  ['Dip']: dip,
};

export default serviceAssets;
